<template>
    <div class="bg-white w-full p-4 rounded overflow-hidden">
        <h3 class="font-bold text-xl page-title mb-8">
            {{ $__('dashboard.account') }}
        </h3>
        <div class="border-b border-gray-200 pb-3 mb-3">
            <span class="text-gray-500 text-sm font-semibold">{{ $__('dashboard.user-company') }}</span>
            <p>{{ user.partnerName }}</p>
        </div>
        <div>
            <span class="text-gray-500 text-sm font-semibold">{{ $__('dashboard.user-status') }}</span>
            <p>{{ 'Dyflexis ' + user.partnerStatus }}</p>
            <div class="mt-3 bg-gray-100 w-full flex justify-center items-center h-28">
                <PremiumPartnerIcon v-if="user.partnerStatus === 'Premium Partner'"/>
                <ResellerIcon v-else-if="user.partnerStatus === 'Reseller'"/>
                <PartnerIcon v-else/>
            </div>
        </div>
    </div>
</template>

<script>
import PartnerIcon from "@/Components/Images/Partner/Regular";
import PremiumPartnerIcon from "@/Components/Images/Partner/Premium";
import ResellerIcon from "@/Components/Images/Partner/Reseller";

export default {
    props: ['user'],
    components: {
        PartnerIcon,
        PremiumPartnerIcon,
        ResellerIcon,
    }
}
</script>
